/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { LocalViewId } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationView.types.tsx';
import { modifyView } from './updateContainerState.tsx';

export const toggleView =
	(localId: LocalViewId): Action<State, Props> =>
	async ({ getState, setState }, props) => {
		const { navigationRemote, cloudId, containerId } = props;
		if (
			!cloudId ||
			!containerId ||
			!navigationRemote ||
			getState().containers[containerId]?.isLoading ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}

		setState(
			modifyView(getState(), containerId, (viewToModify) => {
				if (viewToModify.localId === localId) {
					return {
						...viewToModify,
						isExpanded: !viewToModify.isExpanded,
					};
				}
				return viewToModify;
			}),
		);
	};
